import './index.css'

import { Playground } from './components/playground';

export function App() {
  return <Playground />;
}
